import { lazy } from 'react';

import { RoutesEnum } from '@/enums/routes.enum';

import { IRoutes } from '@/routes/types';

const HomePage = lazy(() => import('@/pages/Home'));
const PrizesPage = lazy(() => import('@/pages/Prizes'));
const TermsConditionsPage = lazy(() => import('@/pages/TermsConditions'));
const FAQPage = lazy(() => import('@/pages/FAQ'));
const HistoryPage = lazy(() => import('@/pages/History'));
const PlayPickPage = lazy(() => import('@/pages/Play'));
const WeeklyStatsPage = lazy(() => import('@/pages/WeeklyStats'));
const LeaderboardPage = lazy(() => import('@/pages/Leaderboard'));
const NotValidRequest = lazy(() => import('@/pages/NotValidRequest'));
const RulesPage = lazy(() => import('@/pages/Rules'));
const ContestRules = lazy(() => import('@/pages/ContestRules'));
const RedirectCallbackPage = lazy(() => import('@/pages/RedirectCallback'));

export const AppRoutes: IRoutes[] = [
  {
    path: RoutesEnum.home,
    element: <HomePage />,
  },
  {
    path: RoutesEnum.prizes,
    element: <PrizesPage />,
  },
  {
    path: RoutesEnum.termsConditions,
    element: <TermsConditionsPage />,
  },
  {
    path: RoutesEnum.faq,
    element: <FAQPage />,
  },
  {
    path: RoutesEnum.history,
    element: <HistoryPage />,
  },
  {
    path: RoutesEnum.play,
    element: <PlayPickPage />,
  },
  {
    path: RoutesEnum.weeklyStats,
    element: <WeeklyStatsPage />,
  },
  {
    path: RoutesEnum.leaderboard,
    element: <LeaderboardPage />,
  },
  {
    path: RoutesEnum.notValidRequest,
    element: <NotValidRequest />,
  },
  {
    path: RoutesEnum.rules,
    element: <RulesPage />,
  },
  {
    path: RoutesEnum.rulesContest,
    element: <ContestRules />,
  },
  {
    path: RoutesEnum.redirectCallback,
    element: <RedirectCallbackPage />,
  },
  {
    path: RoutesEnum.page404,
    element: (
      <p
        style={{
          textAlign: 'center',
          padding: '10px 0',
        }}
      >
        Page not found
      </p>
    ),
  },
];
